import { render, staticRenderFns } from "./TasksListComponent.vue?vue&type=template&id=07f954b0&"
import script from "./TasksListComponent.vue?vue&type=script&lang=js&"
export * from "./TasksListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports